import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default class FeaturedContent {
  constructor({ el, isLargeQuery }) {
    this.el = el;
    this.isLargeQuery = isLargeQuery;
    this.carouselEl = this.el.querySelector('.swiper');

    this.init();
  }

  init() {
    if (this.carouselEl) {
      this.carousel = new Swiper(this.carouselEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          1024: {
            slidesPerView: 2,
          },
        },
      });

      this.prev = this.el.querySelector('.prev');
      this.next = this.el.querySelector('.next');

      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.carousel.slidePrev();
        });
      }

      if (this.next) {
        this.next.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }
    }
  }
}
